import { combineReducers } from "@reduxjs/toolkit";
import reducerAmigurumi from "./slice.store";

const combineRootReducer = combineReducers({
	reducerAmigurumi: reducerAmigurumi,
});
const rootReducer = (state: any, action: any) => {
	// if(action.type === "DESTROY_SESSION"){
	//   state = undefined;
	// }
	return combineRootReducer(state, action);
  }
export default rootReducer;
